@if (isVisible()) {
<div class="notification-mask" (click)="close()"></div>
<div class="notification-tray" #notficationTray>
  <div class="notification-header">
    <span class="header-title">Notifications</span>
    <div class="header-actions">
      <button pButton icon="pi pi-cog"
        class="p-button-text"
        (click)="menu.toggle($event)">
      </button>
      <button pButton icon="pi pi-times"
        class="p-button-text"
        (click)="close()">
      </button>

      <p-menu #menu [popup]="true"
        [model]="menuItems"
        appendTo="body">
      </p-menu>
    </div>
  </div>

  <div class="notification-list">
    @for (notification of notifications; track notification) {
    <div class="notification-item"
      [ngClass]="{'notification-read': notification.read, 'notification-unread': !notification.read}"
      (click)="onNotificationClick(notification)">
      <div class="notification-icon">
        <i class="wh-16 block" [class]="getNotificationIcon(notification.extraParam)"></i>
      </div>
      <div class="notification-content">
        <div class="notification-title text-ellipsis">{{notification.notificationTitle}}</div>
        <div class="notification-description text-ellipsis" [innerHTML]="getNotificationMsgHtml(notification)"></div>
      </div>
      <div class="notification-time">
        {{formatTime(notification.createdAt)}}
      </div>
    </div>
    } @empty {
    <div class="no-notifications">
      <div class="w-full">
        <div class="flex flex-column h-27rem surface-200 p-2 justify-content-center align-items-center style-box">
          <div class="m-3">
            <div class="flex justify-content-center align-items-center">
              <span><i class="{{miIcons.ARCHIVED_SEARCH}} inline-block wh-80"></i></span>
            </div>
            <div class="no-result-div">
              <p translate>lbl_no_results_to_show</p>
            </div>
          </div>
          <div class="mb-4">
            <p class="my-0" translate>lbl_no_records_available1</p>
            <p class="flex justify-content-center" translate>lbl_no_records_available2</p>
          </div>
          <div>
          </div>
        </div>
      </div>

    </div>
    }
  </div>

  <div class="notification-footer">
    @if (notifications.length > 0) {
    <div class="footer-actions">
      @if (notificationCount > (notificationParams?.offset + notificationParams?.limit)) {
      <button pButton label="Load More"
        class="p-button-text"
        (click)="onLoadMore()">
      </button>
      }
    </div>
    }
  </div>
</div>
}